import { z } from "zod"
import { ServiceAdvisorDtoSchema, ServiceGapDtoSchema } from "./ServiceDto"

export const ServiceGapCreateDtoSchema = ServiceGapDtoSchema.omit({ id: true, orgId: true, lastUpdated: true, lastUpdatedByUserId: true, order: true })
export type ServiceGapCreateDto = z.output<typeof ServiceGapCreateDtoSchema>

export const ServiceAdvisorCreateDtoSchema = ServiceAdvisorDtoSchema.omit({ id: true, orgId: true, lastUpdated: true, lastUpdatedByUserId: true, order: true })
export type ServiceAdvisorCreateDto = z.output<typeof ServiceAdvisorCreateDtoSchema>

export const ServiceCreateDtoSchema = z.union([ServiceGapCreateDtoSchema, ServiceAdvisorCreateDtoSchema])
export type ServiceCreateDto = z.output<typeof ServiceCreateDtoSchema>
